import SurveyLocationAdd from "./SurveyLocationAdd";

export default SurveyLocationAdd;
